import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { SxProps, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import { SongEarning } from '@arelia-types/earnings';

interface TableProps {
  rows: SongEarning[];
}

const tableHeadSx: SxProps = {
  fontSize: '14px',
  fontWeight: 'bold'
}

export default function BreakdownBySongsTable({rows}: TableProps) {
  return (
    <TableContainer
      component={Paper}
      sx={{
        border: 'none',
        borderRadius: 'unset',
        boxShadow: 'none',
      }}
    >
      <Table sx={{ minWidth: 650, width: '100%' }}>
        <TableHead>
          <TableRow >
            <TableCell sx={tableHeadSx}>TITLE</TableCell>
            <TableCell sx={tableHeadSx}>SERVICE</TableCell>
            <TableCell sx={tableHeadSx}>ISRC (UPC)</TableCell>
            <TableCell sx={tableHeadSx} align="right">EARNINGS</TableCell>
            <TableCell sx={tableHeadSx} align="right">QUANTITY</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={index}>
              <TableCell component="th" scope="row">
                <Typography fontSize={13}>
                  {row.title}
                </Typography>
                <Typography color={grey[500]} fontSize={11}>
                  {row.artist}
                </Typography>
                <Typography color={grey[500]} fontSize={11}>
                  {row.album}
                </Typography>
              </TableCell>
              <TableCell>{row.networkName}</TableCell>
              <TableCell>{row.isrc ?? '-'} {row.upc && `(${row.upc})`}</TableCell>
              <TableCell align="right">&#36;{row.earning.toFixed(2)}</TableCell>
              <TableCell align="right">{row.quantity.toLocaleString()}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}